import { User } from '../tools';
import environments from '../environments';

export function fetchWithoutRefresh({
  endpoint,
  method,
  body,
  direct = false,
  headers,
  query,
}) {
  const user = User.getUserInfo();
  const queryString = query ? `?${query}` : '';
  const url = direct
    ? endpoint
    : `${environments.API_URL}/api/v1/${endpoint}${queryString}`;

  return fetch(url, {
    method,
    body,
    headers: {
      ...headers,
      'X-User-ID': user.email.replace(/[^\p{L}]/gu, ''),
      'X-API-KEY': user.aiApiKey,
    },
  });
}

const exec = fetchWithoutRefresh;

export const api = {
  get: ({
    endpoint,
    direct = false,
    headers,
    query,
  }) => exec({
    endpoint,
    method: 'GET',
    body: null,
    direct,
    headers,
    query,
  }),

  post: ({
    endpoint,
    body,
    direct = false,
    headers,
  }) => exec({
    endpoint,
    method: 'POST',
    body,
    direct,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  }),

  put: ({
    endpoint,
    body,
    direct = false,
    headers,
    query,
  }) => exec({
    endpoint,
    method: 'PUT',
    body,
    direct,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    query,
  }),

  patch: ({
    endpoint,
    body,
    direct = false,
    headers,
    query,
  }) => exec({
    endpoint,
    method: 'PATCH',
    body,
    direct,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    query,
  }),

  delete: ({
    endpoint,
    body,
    direct = false,
    headers,
    query,
  }) => exec({
    endpoint,
    method: 'DELETE',
    body,
    direct,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    query,
  }),
};
